import { DataFeedClient, DataFeedEngine, type DataFeedHosts, type IEnvService } from './env.types';

export class EnvService implements IEnvService {
  readonly isDevelopmentMode = import.meta.env.DEV;

  readonly isProductionMode = import.meta.env.PROD;

  readonly environment = window.ENVIRONMENT || 'unknown';

  readonly dataFeedHosts: DataFeedHosts = {
    [DataFeedClient.Web]: {
      [DataFeedEngine.Cfd]: window.INTEGRATIONS_HOSTS.dataFeedHostCfdWeb,
      [DataFeedEngine.Crypto]: window.INTEGRATIONS_HOSTS.dataFeedHostCryptoWeb,
    },
    [DataFeedClient.Mobile]: {
      [DataFeedEngine.Cfd]: window.INTEGRATIONS_HOSTS.dataFeedHostCfdMobile,
      [DataFeedEngine.Crypto]: window.INTEGRATIONS_HOSTS.dataFeedHostCryptoMobile,
    },
  };
}
